export const isHangle = (char: string | undefined) => {
  const reg = /[ㄱ-ㅎㅏ-ㅣ가-힣]$/;
  return char ? reg.test(char) : false;
};

export const isCompletedHangle = (char: string | undefined) => {
  const reg = /[가-힣]$/;
  return char ? reg.test(char) : false;
};
